import { mapCTA } from '@websrc/DataMappers/mapCTA'
import {
  CSLocales,
  CSServicebar_MenuItems_Button,
  CSTopbar_MenuItems_Button,
  CSTopbar_MenuItems_Dropdown,
} from '@websrc/Typings/ContentStack'

export function isButton(
  menuItem:
    | CSTopbar_MenuItems_Button
    | CSTopbar_MenuItems_Dropdown
    | ReturnType<typeof mapCTA>
    | CSServicebar_MenuItems_Button
): menuItem is CSTopbar_MenuItems_Button {
  return (menuItem as CSTopbar_MenuItems_Button).button !== undefined
}

export const isCTA = (
  menuItem:
    | CSTopbar_MenuItems_Button
    | CSTopbar_MenuItems_Dropdown
    | ReturnType<typeof mapCTA>
    | CSServicebar_MenuItems_Button
): menuItem is ReturnType<typeof mapCTA> => {
  return !!(menuItem as ReturnType<typeof mapCTA>)?.__ctaType
}

export function checkIsActive(
  currentPath: string,
  menuItem:
    | CSTopbar_MenuItems_Button
    | CSTopbar_MenuItems_Dropdown
    | ReturnType<typeof mapCTA>
    | CSServicebar_MenuItems_Button,
  locale: CSLocales
) {
  if (isButton(menuItem)) {
    return currentPath === menuItem.button.link.href
  }

  if (isCTA(menuItem)) {
    if (menuItem?.__ctaType === 'internal') {
      return `/${locale}${menuItem.url}` === currentPath
    }

    return false
  }

  if ('dropdown' in menuItem) {
    let shouldBeActive = menuItem.dropdown.title_link === currentPath

    menuItem.dropdown.links.forEach((link) => {
      if (link.href === currentPath) shouldBeActive = true
    })

    return shouldBeActive
  }
}
